import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-xs font-label tracking-widest uppercase text-accent-600 mb-3">
              Browse Our Database
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Shop by Category
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base max-w-md leading-relaxed">
            Explore all <strong>mulebuy spreadsheet</strong> product categories. Each category links to our comprehensive database over at kaspreadsheet.com with detailed product listings.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categories.map((cat, index) => {
            const isDark = index === 0 || index === 6 || index === 10;
            return (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                  isDark
                    ? 'bg-primary-700 text-background-50'
                    : 'bg-background-50 text-foreground-950 border border-background-200/60'
                }`}
              >
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <span
                      className={`w-9 h-9 rounded-lg flex items-center justify-center text-base flex-shrink-0 ${
                        isDark
                          ? 'bg-primary-600 text-background-50'
                          : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      <i className={cat.icon}></i>
                    </span>
                    <div>
                      <h3 className={`font-semibold text-base md:text-lg leading-tight ${isDark ? 'text-background-50' : 'text-foreground-950'}`}>
                        {cat.name}
                      </h3>
                      <p className={`text-xs mt-0.5 leading-tight ${isDark ? 'text-background-300/70' : 'text-foreground-500'}`}>
                        {cat.desc}
                      </p>
                    </div>
                  </div>

                  <div className="w-full aspect-[4/3] rounded-lg overflow-hidden mb-4 bg-background-200">
                    <img
                      src={cat.imageUrl}
                      alt={`${cat.name} category for mulebuy spreadsheet`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`${cat.name} - Mulebuy Spreadsheet Category`}
                    />
                  </div>

                  <div className="flex items-center justify-between">
                    <span className={`text-xs ${isDark ? 'text-background-200' : 'text-foreground-500'}`}>
                      View products
                    </span>
                    <span
                      className={`w-8 h-8 rounded-full flex items-center justify-center text-sm transition-colors ${
                        isDark
                          ? 'bg-primary-500 text-background-50 group-hover:bg-primary-400'
                          : 'bg-primary-500 text-background-50 group-hover:bg-primary-600'
                      }`}
                    >
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}